module.exports = __webpack_public_path__ + "media/home2-right.29f6aa00.mp4";